import React, { useEffect } from 'react';
import {
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { getWelcomeText } from '../../../utils/welcomeText';
import { wlog } from '../../../utils/welcomeDebug';

/**
 * Tela 7b — Tamanho dos Grupos por Serviço
 * Só aparece se respondeu "Sim" na Tela 7
 * Para cada serviço, seleciona o tamanho máximo (1-10)
 */
export function Step7bGroupSizes({ wizard, goNext }) {
  wlog('Step7bGroupSizes', 'RENDER', { templateId: wizard.template?.id || 'NENHUM' });
  const template = wizard.template;
  const firstName = wizard.state.userName.split(' ')[0].trim();

  // NÃO focar o título na montagem: durante a animação de transform do trilho,
  // o focus() rola o slide para fora da vista → tela branca.

  const handleGroupSizeChange = (serviceId, newSize) => {
    wizard.setGroupSize(serviceId, newSize);
  };

  const handleContinue = () => {
    goNext();
  };

  return (
    <Container
      maxWidth="md"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100%',
        py: 4,
      }}
      data-step="groupSizes"
    >
      <Box component="section" sx={{ width: '100%' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '24px', md: '28px' },
            fontWeight: 'bold',
            mb: 1,
            color: 'text.primary',
          }}
          tabIndex={-1}
        >
          {getWelcomeText(template, 'groupSizesTitle', { firstName }) ||
            'Quantas pessoas você atende juntas em cada serviço?'}
        </Typography>

        <Typography
          variant="body2"
          sx={{ color: 'text.secondary', mb: 4 }}
        >
          {getWelcomeText(template, 'groupSizesHint', { firstName }) ||
            'Deixe em 1 os serviços individuais. Para turmas, selecione a capacidade da sessão.'}
        </Typography>

        <Stack spacing={3} sx={{ mb: 4 }}>
          {wizard.state.services.map((service) => (
            <Box
              key={service.id}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 2,
                bgcolor: 'background.default',
                borderRadius: 1,
              }}
            >
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {service.name}
              </Typography>

              <FormControl sx={{ minWidth: 120 }}>
                <Select
                  value={wizard.state.groupSizes[service.id] ?? 1}
                  onChange={(e) =>
                    handleGroupSizeChange(service.id, e.target.value)
                  }
                  size="small"
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                    <MenuItem key={num} value={num}>
                      {num === 10 ? '+10 (máximo)' : `${num}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          ))}
        </Stack>

        {/* Nota do plano gratuito se houver +10 selecionado */}
        {Object.values(wizard.state.groupSizes).some((size) => size >= 10) && (
          <Box
            sx={{
              p: 2,
              mb: 4,
              bgcolor: 'info.lighter',
              border: '1px solid',
              borderColor: 'info.light',
              borderRadius: 1,
            }}
          >
            <Typography variant="body2" sx={{ color: 'info.dark' }}>
              {getWelcomeText(template, 'groupSizesMaxNote', { firstName }) ||
                '10 é o máximo do plano gratuito. Para turmas maiores, dá pra assinar um plano pago depois.'}
            </Typography>
          </Box>
        )}

        <Button
          variant="contained"
          size="large"
          onClick={handleContinue}
          sx={{
            width: '100%',
            py: 1.5,
            mt: 2,
          }}
        >
          Continuar
        </Button>
      </Box>
    </Container>
  );
}

export default Step7bGroupSizes;
